import { DownOutlined, FormOutlined } from "@ant-design/icons";
import { Dropdown, Input, Menu, Space, Typography, Form } from "antd";
import Table, { ColumnsType, TablePaginationConfig } from "antd/lib/table";
import { AddBannerModal, EditBannerModal } from "components";
import React, { useEffect, useState } from "react";
import "./style.scss";
import { api } from "services/api";

export const ManageBanners: React.FC = () => {
	const [selectedValue, setSelecteValue] = useState<string>("10");
	const [currentImgURL, setCurrentImgURL] = useState<string>("");
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const [isOpenEdit, setIsOpenEdit] = useState<boolean>(false);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [banners, setBanners] = useState<any[]>();
	const [paginationInfo, setPaginationInfo] = useState<TablePaginationConfig>();
	const [totalItensValue, setTotalItensValue] = useState<number>(0);
	const [currentBannerInfo, setCurrentBannerInfo] = useState<any>();
	const [form] = Form.useForm();
	const [editForm] = Form.useForm();
	const getUpdatedInfo = async (id: string) => {
		setIsLoading(true);
		if (banners) {
			const {
				data: {
					data: { banner },
				},
			} = await api.get(`/banners/${id}`);
			setIsLoading(false);
			setCurrentBannerInfo(banner);
		}
	};
	const menu = (
		<Menu
			selectable
			onClick={(e) => setSelecteValue(e.key)}
			defaultSelectedKeys={["3"]}
			items={[
				{
					key: "10",
					label: "10",
				},
				{
					key: "20",
					label: "20",
				},
				{
					key: "30",
					label: "30",
				},
				{
					key: "40",
					label: "40",
				},
			]}
		/>
	);

	const columns: ColumnsType<any> = [
		{
			title: "Título do banner",
			dataIndex: "title",
			key: "title",
			render: (text) => <p style={{ margin: 0 }}>{text}</p>,
			onCell: () => {
				return {
					width: "12%",
				};
			},
		},
		{
			title: "Descrição",
			dataIndex: "description",
			key: "description",
		},
		{
			title: "Cadastrado em",
			dataIndex: "created_at",
			key: "created_at",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: () => {
				return {
					width: "11%",
				};
			},
		},
		{
			title: "Última edição",
			dataIndex: "updated_at",
			key: "updated_at",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: () => {
				return {
					width: "11%",
				};
			},
		},
		{
			title: "Ordem",
			dataIndex: "order",
			key: "order",
			render: (order) => <p style={{ margin: 0 }}>{order}</p>,
		},
		{
			title: "URL",
			dataIndex: "url",
			key: "url",
			render: (url) => <p style={{ margin: 0 }}>{url}</p>,
		},
		{
			title: "",
			key: "",
			render: (_, record) => (
				<Space size="middle">
					<FormOutlined
						className="edit"
						onClick={async () => {
							await getUpdatedInfo(`${record?.id}`);
							setIsOpenEdit(true);
						}}
					/>
				</Space>
			),
		},
	];

	useEffect(() => {
		setBanners(undefined);
		api
			.get(
				`/banners?per_page=${selectedValue}&paginate=true&page=${
					paginationInfo?.current ? paginationInfo.current : 1
				}`
			)
			.then((res) => {
				setBanners(res?.data?.data?.banners);
				setTotalItensValue(Number(res?.data?.pagination?.total));
			});
	}, [selectedValue, paginationInfo]);

	return (
		<div className="users">
			<AddBannerModal
				form={form}
				isOpen={isOpen}
				setIsOpen={setIsOpen}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				setBanners={setBanners}
			/>
			<EditBannerModal
				form={editForm}
				setIsOpen={setIsOpenEdit}
				isOpen={isOpenEdit}
				currentBannerInfo={currentBannerInfo}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				setBanners={setBanners}
			/>

			<div className="users__container">
				<h1 className="users__container__title">Banners</h1>
				<div className="users__container__input">
					<div className="users__container__input__user-number">
						Exibir{" "}
						{
							<Dropdown overlay={menu}>
								<Typography.Text>
									{selectedValue}
									<DownOutlined style={{ marginLeft: "5px" }} />
								</Typography.Text>
							</Dropdown>
						}{" "}
						banners
					</div>
					<Input placeholder="Pesquisar..." />
					<button
						className="users__container__input__btn"
						onClick={() => setIsOpen(true)}
					>
						+ Adicionar Banner
					</button>
				</div>
				<Table
					loading={banners === undefined || isLoading}
					columns={columns}
					dataSource={banners}
					onChange={(e) => setPaginationInfo(e)}
					pagination={{
						total: totalItensValue,
						showSizeChanger: false,
						pageSize: +selectedValue,
					}}
				/>
			</div>
		</div>
	);
};
